<template>
  <div>
    <v-row v-if="!data_loaded">
      <v-col v-for="i in 7" :key="i" cols="6" sm="3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-card class="mt-10 mb-10" v-if="data_loaded">
      <v-card-title>
        <div class="d-flex align-center">
          <v-icon x-large>tune</v-icon>
          <h1 class="ms-3">הגדרות מתקדמת</h1>
        </div>
        <v-spacer></v-spacer>
        <v-btn text exact to="/settings" color="primary">
          <v-icon>keyboard_backspace</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row class="basic mt-2">
            <v-col class="py-0" cols="3">
              <v-switch v-model="item.show_search_barcode">
                <template slot="label">
                  <span class="mx-3"> חיפוש בברקוד </span>
                </template>
              </v-switch>
            </v-col>
            <v-col class="py-0" cols="3">
              <v-switch v-model="item.otp_login">
                <template slot="label">
                  <span class="mx-3"> אימות כניסה בקוד SMS</span>
                </template>
              </v-switch>
            </v-col>
            <v-col class="py-0" cols="3">
              <v-switch v-model="item.self_pick_up">
                <template slot="label">
                  <span class="mx-3"> איסוף עצמי </span>
                </template>
              </v-switch>
            </v-col>
            <v-col class="py-0" cols="3" v-if="!special_customers_persisted">
              <v-switch v-model="item.special_customers">
                <template slot="label">
                  <span class="mx-3"> הזמנות מיוחדות</span>
                </template>
              </v-switch>
            </v-col>

            <v-col class="py-0" cols="3" v-if="!item.special_customers">
              <v-switch v-model="item.stop_add_special_orders">
                <template slot="label">
                  <span class="mx-3">עצירת הוספת הזמנות מיוחדות</span>
                </template>
              </v-switch>
            </v-col>

            <v-col class="py-0" cols="3">
              <v-switch v-model="item.is_busy">
                <template slot="label">
                  <span class="mx-3"> עסקים עם משאבים</span>
                </template>
              </v-switch>
            </v-col>

            <v-col class="py-0" cols="3">
              <v-select
                outlined
                dense
                v-model="item.delivery_id"
                :items="deliveries"
                label="סוג משאבים"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>

            <v-col class="py-0" cols="3">
              <v-select
                outlined
                dense
                v-model="item.status_to_create_the_invoice"
                :items="order_statuses"
                label="סטטוס ליצירת חשבונית"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row class="mt-2 align-center">
            <v-col class="py-0" cols="12" md="4">
              <v-switch v-model="item.send_invoice_sms_to_customer">
                <template slot="label">
                  <span class="mx-3"> שליחת SMS חשבונית ללקוח </span>
                </template>
              </v-switch>
            </v-col>

            <v-col class="py-0" cols="12" md="8" v-if="item.send_invoice_sms_to_customer">
              <v-text-field
                outlined
                dense
                v-model="item.send_invoice_sms_to_customer_message"
                label="הודעת SMS לחשבונית"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end pa-8">
        <v-btn
          @click="save()"
          :loading="save_loader"
          :disabled="save_loader"
          x-large
          depressed
          height="40"
          color="black white--text ms-3"
          >שמירה</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-snackbar left v-model="snackbar">
      <p class="white--text">ההגדרות עודכנו בהצלחה</p>
      <template v-slot:action>
        <v-icon color="green" class="ms-3">check_circle</v-icon>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "a",
  data() {
    return {
      data_loaded: false,
      snackbar: false,
      save_loader: false,
      deliveries: [],
      special_customers_persisted: false,
      item: {
        show_search_barcode: false,
        otp_login: false,
        self_pick_up: false,
        special_customers: false,
        stop_add_special_orders: false,
        is_busy: false,
        delivery_id: null,
        send_invoice_sms_to_customer: false,
        send_invoice_sms_to_customer_message: "",
        status_to_create_the_invoice: "ready",
      },
      order_statuses: [
        { text: "חדש (New)", value: "new" },
        { text: "בהכנה (Preparation)", value: "preparation" },
        { text: "מוכן (Ready)", value: "ready" },
        { text: "בדרך (In Progress Delivery)", value: "in_progress_delivery" },
        { text: "הגיע השליח (Delivery Arrived)", value: "delivery_arrived" },
        { text: "טופל (Done)", value: "done" },
      ],
    };
  },
  methods: {
    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "settings/advanced",
            method: "get",
          },
        })
        .then((res) => {
          const data = res.data.data;

          if (data) {
            this.item = Object.assign({}, data);
            this.special_customers_persisted = !!data.special_customers;
          }

          this.get_deliveries();
        });
    },
    get_deliveries() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "/delivery",
            method: "get",
          },
        })
        .then((res) => {
          this.deliveries = Object.assign([], res.data.data);
          this.deliveries.unshift({
            id: null,
            name: "בלי",
          });
          this.$nextTick(() => {
            this.data_loaded = true;
          });
        });
    },
    save() {
      if (!this.save_loader && this.data_loaded) {
        this.save_loader = true;
        this.$store
          .dispatch("public__request", {
            config: {
              url: "settings/advanced",
              method: "POST",
            },
            data: this.item,
          })
          .then((res) => {
            this.save_loader = false;
            this.snackbar = true;
            this.get_data();
          })
          .catch((err) => {
            this.save_loader = false;
          });
      }
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>
